<footer class="bg-base-100 text-base-content">
  <div class="footer-main">
    <div class="footer-mission">
      <p class="footer-mission-title">We're on a mission to save education.</p>
      <p class="footer-mission-copy">
        Be a Hero and join us in making all the difference!
        <a href="/get-involved" class="link link-hover">Donate</a> or
        <a href="/get-involved" class="link link-hover"
          >Contribute Your Skills</a
        >
        now!
      </p>
      <a href="/get-involved" class="footer-cta text-sm font-semibold"
        >Get Involved <span aria-hidden="true">→</span></a
      >
    </div>
    <nav class="footer-section" aria-label="Contribute">
      <h2 class="footer-heading font-bangers tracking-widest">Contribute</h2>
      <button
        type="button"
        class="footer-toggle font-bangers tracking-widest"
        [attr.aria-expanded]="expandedSection === 'contribute'"
        aria-controls="footer-contribute"
        (click)="toggleSection('contribute')"
      >
        Contribute
        <span aria-hidden="true">{{
          expandedSection === 'contribute' ? '−' : '+'
        }}</span>
      </button>
      <ul
        id="footer-contribute"
        class="footer-links list-none"
        [class.is-open]="expandedSection === 'contribute'"
      >
        <li>
          <a href="/get-involved" class="link link-hover">Create Content</a>
        </li>
        <li><a href="/get-involved" class="link link-hover">Shop</a></li>
        <li><a href="/get-involved" class="link link-hover">Subscribe</a></li>
        <li>
          <a href="/get-involved" class="link link-hover">Translate Content</a>
        </li>
        <li>
          <a href="/get-involved" class="link link-hover">Ask and Answer</a>
        </li>
        <li>
          <app-share
            [buttonText]="'Share'"
            [buttonClasses]="'btn-primary btn-fast'"
          ></app-share>
        </li>
      </ul>
    </nav>
    <nav class="footer-section" aria-label="Company and resources">
      <h2 class="footer-heading font-bangers tracking-widest">Company</h2>
      <button
        type="button"
        class="footer-toggle font-bangers tracking-widest"
        [attr.aria-expanded]="expandedSection === 'company'"
        aria-controls="footer-company"
        (click)="toggleSection('company')"
      >
        Company &amp; Resources
        <span aria-hidden="true">{{
          expandedSection === 'company' ? '−' : '+'
        }}</span>
      </button>
      <div
        id="footer-company"
        class="footer-links"
        [class.is-open]="expandedSection === 'company'"
      >
        <ul class="list-none">
          <li><a href="/about" class="link link-hover">About us</a></li>
          <li><a href="/contact" class="link link-hover">Contact Us</a></li>
        </ul>
        <h2
          class="footer-heading footer-subheading font-bangers tracking-widest"
        >
          Other
        </h2>
        <ul class="list-none">
          <li><a href="/changelog" class="link link-hover">Changelog</a></li>
          <li>
            <a href="/mother-tongue-education-benefits" class="link link-hover"
              >Mother Tongue Education Benefits</a
            >
          </li>
        </ul>
      </div>
    </nav>
    <nav class="footer-section" aria-label="Terms and policies">
      <h2 class="footer-heading font-bangers tracking-widest">
        Terms And Policies
      </h2>
      <button
        type="button"
        class="footer-toggle font-bangers tracking-widest"
        [attr.aria-expanded]="expandedSection === 'policies'"
        aria-controls="footer-policies"
        (click)="toggleSection('policies')"
      >
        Terms And Policies
        <span aria-hidden="true">{{
          expandedSection === 'policies' ? '−' : '+'
        }}</span>
      </button>
      <ul
        id="footer-policies"
        class="footer-links list-none"
        [class.is-open]="expandedSection === 'policies'"
      >
        <li><a href="/terms" class="link link-hover">Terms of use</a></li>
        <li><a href="/privacy" class="link link-hover">Privacy policy</a></li>
        <li><a href="/cookie" class="link link-hover">Cookie policy</a></li>
      </ul>
    </nav>
  </div>
  <div class="footer-bottom border-t border-base-300">
    <aside class="footer-brand">
      <img
        src="assets/images/logo-h-e.svg"
        alt="Study Heroes"
        width="260"
        class="footer-logo"
      />
      <p class="footer-tagline">
        <span class="font-bold font-bangers tracking-widest">Study Heroes</span>
        <br />Putting the power of education back into the hands of the people.
      </p>
    </aside>
    <nav aria-label="Social media">
      <div class="footer-socials">
        <a
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Study Heroes on X"
          href="https://x.com/studyheroesapp"
          class="transition-color"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            width="24"
            height="24"
            viewBox="0 0 1668.56 1221.19"
            class="social-link xcom"
            fill="currentColor"
          >
            <path
              d="m283.94 167.31 386.39 516.64-388.83 420.05h87.51l340.42-367.76 275.05 367.76h297.8l-408.13-545.7 361.92-390.99h-87.51l-313.51 338.7-253.31-338.7zm128.69 64.46h136.81l604.13 807.76h-136.81z"
              transform="translate(52.390088 -25.058597)"
            />
          </svg>
        </a>
        <a
          href="https://www.youtube.com/@StudyHeroes"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Study Heroes on YouTube"
          class="transition-color hover:text-red-600"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
            ></path>
          </svg>
        </a>
      </div>
    </nav>
  </div>
</footer>
